const mimeSignatures = {
    "application/pdf": ["25504446"], // %PDF
    "application/msword": ["D0CF11E0A1B11AE1"], // DOC (OLE Compound File)
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["504B0304"], // DOCX (ZIP based)
    "application/vnd.ms-excel": ["D0CF11E0A1B11AE1"], // XLS (OLE Compound File)
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["504B0304"], // XLSX (ZIP based)
    "text/csv": [], // CSV has no magic bytes
    "image/jpeg": ["FFD8FF"], // JPEG
    "image/png": ["89504E470D0A1A0A"], // PNG
};
const mimeExtensions = {
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "text/csv": "csv",
    "image/jpeg": "jpg",
    "image/png": "png",
};
const bufferToHex = (buffer) => Array.from(buffer)
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();
export const getExtensionForMime = (mime) => mimeExtensions[mime] || "";
export const readFileHeader = async (file, length = 16) => {
    const buffer = await file.slice(0, length).arrayBuffer();
    return new Uint8Array(buffer);
};
export const confirmMimeWithMagicBytes = async (file, mime) => {
    const signatures = mimeSignatures[mime];
    if (!signatures || signatures.length === 0) {
        return {
            ok: true,
            expectedMagicBytes: undefined,
            actualMagicBytes: "",
        };
    }
    const header = await readFileHeader(file, 16);
    const actualMagicBytes = bufferToHex(header);
    const ok = signatures.some((sig) => actualMagicBytes.startsWith(sig.toUpperCase()));
    return {
        ok,
        expectedMagicBytes: signatures,
        actualMagicBytes,
    };
};
